import {DocumentResource, Resource} from 'ngx-jsonapi';

import {Test} from './test';
import {Exam} from './exam';
import {GroupWork} from './group-work';

export class Question extends Resource {
  public attributes = {
    question: '',
    old_id: '',
    questionType: ''
  };
  public relationships = {
    test: new DocumentResource<Test>(),
    exam: new DocumentResource<Exam>(),
    groupWork: new DocumentResource<GroupWork>(),
  };
}
